import Vue from 'vue'
import Input from './Input'

const component = {
  install() {
    Vue.component('EInput', Input)
  } // 'component-name'这就是后面可以使用的组件的名字，install是默认的一个方法
}
Vue.use(component)
